module.exports = __webpack_public_path__ + "img/New-2.70a25047.png";